import axios from 'axios';

const BASE_URL = process.env.VUE_APP_APIURL;

// cannot be set through the "change transfer status" dialogs - only via the dedicated
// cancel-production action or the RePort not-accepted job
const PRODUCTION_CANCELLED_STATUS_ID = 27;
// server-only - set when a bot takes the transfer, never through the dialogs
const BOT_PENDING_STATUS_ID = 28;

const get = (manualStatusOnly = false, excludeStatusIds = []) => {
    const applyExclude = (data) => (excludeStatusIds.length
        ? data.filter((i) => !excludeStatusIds.includes(i.Value))
        : data);

    if (!manualStatusOnly && get.cache) {
        return Promise.resolve(applyExclude(get.cache));
    }
    return axios.get(`${BASE_URL}/api/TransferStatuses?manualStatusOnly=${manualStatusOnly}`)
    .then((r) => {
        const cache = r.data.map((i) => ({ Value: i.Id, Text: i.Name }));
        if (!manualStatusOnly) {
            get.cache = cache;
        }
        return applyExclude(cache);
    })
    .catch((err) => console.log(err));
};

export default {
    get,
    PRODUCTION_CANCELLED_STATUS_ID,
    BOT_PENDING_STATUS_ID,
};
